// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
/**
 * Runtime enum style object for attribute change operation types
 */
export var AttributeChangeOp = createEnumStyle({
    Clear: 0 /* eAttributeChangeOp.Clear */,
    Set: 1 /* eAttributeChangeOp.Set */,
    Add: 2 /* eAttributeChangeOp.Add */,
    Delete: 3 /* eAttributeChangeOp.Delete */
});
//# sourceMappingURL=eAttributeChangeOp.js.map